import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
interface FAQItem {
  question: string;
  answer: string;
}
const faqs: FAQItem[] = [{
  question: '¿Cuándo voy a ver los primeros resultados?',
  answer: 'La mayoría de las personas nota cambios en la energía y en las mediciones a partir del tercer o cuarto día. Los resultados más significativos en la glucosa en ayunas suelen aparecer entre el día 5 y el día 10. Cada organismo es diferente, pero el protocolo está diseñado para que los cambios sean rápidos y perceptibles desde la primera semana.'
}, {
  question: '¿Puedo seguir tomando mi medicación mientras hago el protocolo?',
  answer: 'Sí, absolutamente. El protocolo es un complemento natural y no interfiere con los medicamentos convencionales. De hecho, muchos usuarios reportan que con el tiempo su médico les reduce la dosis porque los niveles mejoran. Nunca suspenda ni modifique su medicación sin consultar a su médico primero.'
}, {
  question: '¿Dónde consigo las hierbas en Uruguay?',
  answer: 'Esa es justamente una de las ventajas del protocolo: todas las hierbas se consiguen fácilmente en Uruguay. Las encontrará en la feria del barrio, en herboristerías, en algunos almacenes del interior y en tiendas naturistas. La guía incluye los nombres comunes en Uruguay para que no haya confusión al comprarlas.'
}, {
  question: '¿Funciona para la diabetes tipo 1 también?',
  answer: 'El protocolo está diseñado específicamente para personas con diabetes tipo 2, pre-diabetes o glucosa elevada. Las personas con diabetes tipo 1 tienen una condición autoinmune diferente y deben consultar con su médico antes de iniciar cualquier protocolo natural. Para tipo 2 y pre-diabetes, los resultados son los más documentados.'
}, {
  question: '¿Cómo recibo el producto después de comprarlo?',
  answer: 'Es una descarga digital inmediata. Apenas confirme el pago, recibirá un correo electrónico con el enlace para descargar el PDF directamente a su celular, tablet o computadora. No hay espera, no hay envío físico. Puede empezar a leer en los próximos 5 minutos.'
}, {
  question: '¿Tengo que hacer una dieta muy estricta?',
  answer: 'No. Ese es precisamente el punto diferencial del protocolo. No le pedimos que deje el asado, el mate ni las reuniones familiares. Le enseñamos cómo manejar esos momentos con estrategias simples. El objetivo es que esto sea sostenible a largo plazo, no una tortura de dos semanas.'
}, {
  question: '¿Qué pasa si no me funciona? ¿Puedo pedir el reembolso?',
  answer: 'Sí, sin ningún problema. Tiene 7 días de garantía total. Si por cualquier motivo no está satisfecho — no vio resultados, no le gustó el contenido, o simplemente cambió de opinión — le devolvemos el dinero completo. Solo escríbanos por correo y procesamos el reembolso sin preguntas ni demoras.'
}, {
  question: '¿Es seguro para personas mayores de 65 años?',
  answer: 'Sí. El protocolo está basado en hierbas de uso tradicional en la región, con siglos de historia de uso seguro. No contiene estimulantes ni sustancias agresivas. Muchos de nuestros usuarios tienen entre 60 y 75 años y lo toleran perfectamente. Igual, si tiene alguna condición médica específica, siempre es bueno comentárselo a su médico.'
}];
function FAQItem({
  question,
  answer
}: FAQItem) {
  const [open, setOpen] = useState(false);
  return <div className="border border-gray-200 rounded-xl overflow-hidden" data-id="element-18">
      <button onClick={() => setOpen(!open)} className="w-full flex items-center justify-between gap-4 px-6 py-5 text-left bg-white hover:bg-gray-50 transition-colors" aria-expanded={open} data-id="element-19">
        <span className="font-semibold text-gray-900 text-base" data-id="element-20">
          {question}
        </span>
        {open ? <ChevronUp className="h-5 w-5 text-[#1a4a2e] flex-shrink-0" data-id="element-21" /> : <ChevronDown className="h-5 w-5 text-gray-400 flex-shrink-0" data-id="element-22" />}
      </button>
      {open && <div className="px-6 pb-5 bg-white border-t border-gray-100" data-id="element-23">
          <p className="text-gray-700 leading-relaxed pt-4 text-sm md:text-base" data-id="element-24">
            {answer}
          </p>
        </div>}
    </div>;
}
export function FAQSection() {
  return <section className="py-16 px-4 bg-white" data-id="element-25">
      <div className="max-w-3xl mx-auto" data-id="element-26">
        <div className="text-center mb-10" data-id="element-27">
          <div className="inline-block bg-emerald-100 text-emerald-800 px-4 py-1 rounded-full text-sm font-bold mb-4 uppercase tracking-wide" data-id="element-28">
            Preguntas frecuentes
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-[#1a4a2e] mb-3" data-id="element-29">
            Sus Dudas, Respondidas
          </h2>
          <p className="text-gray-600" data-id="element-30">
            Si tiene alguna pregunta que no está acá, escríbanos y le
            respondemos en el día.
          </p>
        </div>

        <div className="flex flex-col gap-3" data-id="element-31">
          {faqs.map(faq => <FAQItem key={faq.question} question={faq.question} answer={faq.answer} data-id="element-32" />)}
        </div>

        <div className="mt-10 text-center bg-emerald-50 border border-emerald-200 rounded-2xl p-6" data-id="element-33">
          <p className="text-emerald-800 font-semibold mb-1" data-id="element-34">
            ¿Todavía tiene dudas?
          </p>
          <p className="text-emerald-700 text-sm" data-id="element-35">
            Escríbanos a{' '}
            <span className="font-bold" data-id="element-36">remediosnaturales300@gmail.com</span> y
            le respondemos en menos de 24 horas.
          </p>
        </div>
      </div>
    </section>;
}